import { Translate } from 'react-admin';
import { CellType, GridColDef } from 'types/mui.types';
import {
  formatColumnValueType,
  formatColumnValueTypeLocation,
} from 'features/realEstates/list/utils/columnsValueFormatters';
import {
  renderCellActionsCGP,
  renderCellHighlighted,
  renderCellStatus,
  renderIsBookedCell,
} from 'features/realEstates/list/utils/columnsRenderCell';
import { formatYesNoOrAnyValue } from 'utils/columns/valueFormatters.utils';

export const getRealEstatesColumnsCGP = (
  translate: Translate
): GridColDef[] => {
  return [
    {
      field: 'actions',
      headerName: '',
      renderCell: renderCellActionsCGP(translate),
      sortable: false,
      width: 80,
    },
    {
      field: 'status',
      headerName: 'realEstate.statusLabel',
      renderCell: renderCellStatus(translate),
      width: 130,
    },
    {
      field: 'isBooked',
      headerName: 'realEstate.isBooked',
      renderCell: renderIsBookedCell(),
    },
    {
      field: 'address.street',
      headerName: 'shared.address.street',
      renderCell: renderCellHighlighted(),
      width: 200,
    },
    {
      field: 'address.city',
      headerName: 'shared.address.city',
      renderCell: renderCellHighlighted(),
      width: 140,
    },
    {
      cellType: CellType.PRICE,
      field: 'financialModel.projectAmount',
      headerName: 'financial.totalBudget',
      width: 130,
    },
    {
      cellType: CellType.PERCENTAGE,
      field: 'financialModel.grossReturn',
      headerName: 'financial.grossReturn',
      width: 130,
    },
    {
      cellType: CellType.PERCENTAGE,
      field: 'financialModel.netReturn',
      headerName: 'financial.netReturn',
      width: 130,
    },
    {
      cellType: CellType.PRICE,
      field: 'financialModel.salesPrice',
      headerName: 'financial.salesPrice',
      width: 130,
    },
    {
      field: 'surface',
      headerName: 'realEstate.surface',
      width: 130,
    },
    {
      field: 'type',
      headerName: 'realEstate.propertyType',
      valueFormatter: formatColumnValueType(translate),
      width: 150,
    },
    {
      field: 'mandator.fullName',
      headerName: 'shared.mandator.fullName',
      renderCell: renderCellHighlighted(),
      width: 200,
    },
    {
      field: 'mandator.email',
      headerName: 'shared.mandator.email',
      width: 200,
    },
    {
      field: 'mandator.phoneNumber',
      headerName: 'shared.mandator.phone',
      width: 200,
    },
    {
      field: 'totalLots',
      headerName: 'realEstate.totalLots',
      width: 130,
    },
    {
      field: 'roomNumber',
      headerName: 'realEstate.roomNumber',
      width: 130,
    },
    {
      field: 'dpe',
      headerName: 'realEstate.dpe',
      width: 130,
    },
    {
      cellType: CellType.DATE_TIME,
      field: 'createdAt',
      headerName: 'realEstate.createdAt',
      width: 200,
    },
    {
      cellType: CellType.DATE_TIME,
      field: 'lastPublishedAt',
      headerName: 'shared.publicationDate',
      width: 200,
    },
    {
      field: 'locationType',
      headerName: 'realEstate.locationType',
      valueFormatter: formatColumnValueTypeLocation(translate),
      width: 130,
    },
    {
      field: 'groundFloor',
      headerName: 'realEstate.groundFloor',
      sortable: false,
      valueFormatter: formatYesNoOrAnyValue,
      width: 130,
    },
  ] as GridColDef[];
};
